import React from "react";
import styles from "./Hero.module.css";
import { Animate } from "../../animations";

function Hero({ heading }) {
  return (
    <div className={styles.about_hero_section}>
      <Animate variant="fadeUp" duration={800}>
        <h1 id="heading-large" style={{ color: "var(--white)" }}>
          {heading}
        </h1>
      </Animate>
    </div>
  );
}

export default Hero;
